<template>
  <div class="home">
    <div @click="jump">跳转</div>
    <svg width="300" height="10">
      <defs>
        <linearGradient id="grad1" x1="0%" y1="0%" x2="100%" y2="0%">
          <stop offset="0%" style="stop-color:rgb(255,255,0);stop-opacity:1" />
          <stop offset="100%" style="stop-color:rgb(255,0,0);stop-opacity:1" />
        </linearGradient>
      </defs>
      <path
        d="M30 0 L270 0 L270 10 L30 10 Z"
        stroke="#999"
        stroke-width="1"
        fill="#999"
        stroke-linecap="round"
      />
      <path
        d="M30 0 L50 0 L50 10 L30 10 Z"
        stroke="#999"
        stroke-width="1"
        fill="url(#grad1)"
        stroke-linecap="round"
      >
        <animate
          attributeName="d"
          attributeType="XML"
          from="M30 0 L50 0 L50 10 L30 10 Z"
          to="M30 0 L270 0 L270 10 L30 10 Z"
          dur="2s"
          fill="freeze"
        />
      </path>
    </svg>
    <div class="tab-bar">
      <div class="container1" @click="clickHome">
        <svg class="svg-class" id="home" viewBox="0 0 1024 1024" width="40" height="40">
          <circle
            cx="512"
            cy="512"
            r="512"
            fill="none"
            :class="[showCircle ? 'home-circle-class' : '']"
          ></circle>
          <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
            <stop offset="0%" style="stop-color: rgb(231, 56, 40); stop-opacity: 1" />
            <stop offset="100%" style="stop-color: rgb(243, 20, 99); stop-opacity: 1" />
          </linearGradient>
          <path
            :class="[showCircle ? 'home-class' : 'home-class-native']"
            d="M562.80517578 80.6975a72.135 72.135 0 0 0-96.93017578 0L73.925 452.86982422a36.1575 36.1575 0 0 0 48.42 53.7075l6.2325-5.9175V889.1a72.315 72.315 0 0 0 72.315 72.405h210.44267578v-217.71035156a50.9175 50.9175 0 0 1 50.94-50.985h99.02285156a50.9175 50.9175 0 0 1 50.94 50.985v217.71035156h215.4375a72.315 72.315 0 0 0 72.3375-72.405V505.40732422c16.065 14.535 38.8575 13.4325 52.2225-1.4625a36.1575 36.1575 0 0 0-2.61-51.075L562.80517578 80.72Z"
            fill="#333333"
          ></path>
          <circle cx="512" cy="550" r="80" fill="none" :class="[showCircle ? 'little-circle' : '']">
            <animate
              attributeName="cy"
              attributeType="XML"
              from="600"
              to="500"
              dur=".3s"
              begin="home.click"
              repeatCount="1"
              fill="freeze"
            ></animate>
          </circle>
        </svg>
        <span>首页</span>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "Home",
  setup() {
    const router = useRouter();
    const showCircle = ref(false);
    const jump = () => {
      router.push({
        name: "LivingDetail",
        query: {
          // columnsId: 24
          radioStationCode: "962",
          programId: 1,
          playType: "living"
        }
      });
    };

    const clickHome = () => {
      showCircle.value = true;
    };

    return {
      jump,
      showCircle,
      clickHome
    };
  }
});
</script>

<style lang="scss" scoped>
.tab-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 65px;
  background: #ccc;
}

.container1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  text-align: center;
  color: #111;
}

.home-class {
  stroke-width: 50;
  transform-origin: 50% 50%;
  transform: scale(0.8);
  animation: home 0 linear 1 forwards;
}

.home-class-native {
  fill: none;
  transform-origin: 50% 50%;
  transform: scale(0.8);
  stroke-width: 50;
  stroke: #111;
}

.little-circle {
  fill: white;
}

.home-circle-class {
  fill: url("#orange_red");
}

@keyframes home {
  from {
    fill: none;
  }

  to {
    fill: #111;
  }
}
</style>
